import React, { useEffect, useState } from 'react';
import Icon from '../../../../generic-components/Icon';
import { getPlacePhoto, getStaticMapUrl, MAP_WEB_VIEW_URL } from '../../../../services/googleMaps.service';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';

interface IProps {
  locationDetails?: any;
}

const defaultParams = {
  mapZoom: '17',
  mapSize: '280x100',
  placePhotoMaxWidth: '400',
};

const BusinessPictureMap = ({ locationDetails }: IProps) => {
  const [mapUrl, setMapUrl] = useState<string>('');
  const [photoUrl, setPhotoUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchStaticMap = async () => {
    const { latitude, longitude } = locationDetails;
    if (!latitude || !longitude) return '';
    const staticMapUrl = await getStaticMapUrl({ center: { latitude, longitude }, zoom: defaultParams.mapZoom, size: defaultParams.mapSize });
    return staticMapUrl;
  };

  const fetchPlacePhoto = async () => {
    const { photos } = locationDetails;
    if (!photos) return '';
    const hydratedPhotoList = JSON.parse(photos);
    const ref = hydratedPhotoList[0].photoReference;
    const url = await getPlacePhoto({ maxWidth: defaultParams.placePhotoMaxWidth, ref });
    return url;
  };

  const initFetch = async () => {
    const map = await fetchStaticMap();
    const photo = await fetchPlacePhoto();
    if (map) setMapUrl(map);
    if (photo) setPhotoUrl(photo);
    setIsLoading(false);
  };

  // Cleanup the objectURL we created
  useEffect(() => function cleanup() {
    if (mapUrl) {
      URL.revokeObjectURL(mapUrl);
    }
    if (photoUrl) {
      URL.revokeObjectURL(photoUrl);
    }
  });

  useEffect(() => {
    if (locationDetails) {
      setIsLoading(true);
      initFetch();
    } else {
      setMapUrl('');
      setPhotoUrl('');
    }
  }, [locationDetails]);

  const handleAssetClick = () => {
    const { latitude, longitude } = locationDetails;
    if (!longitude || !latitude) return;
    window.open(MAP_WEB_VIEW_URL
      .replace('latitude', latitude)
      .replace('longitude', longitude), '_blank')?.focus();
  };

  return isLoading ? <div className='flex h-20 items-center justify-center'><Spinner spinnerColor={SpinnerColor.Blue} height='34px' width='34px' /></div> : (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={handleAssetClick} className='flex items-center gap-x-1.5 h-20 hover:cursor-pointer'>
      {mapUrl && (
        <div className='w-full h-full'>
          <Icon iconId='transactionDetailsMap' className='w-full h-full object-cover' src={mapUrl} />
        </div>
      )}
      {photoUrl && (
        <div className='w-full h-full'>
          <Icon iconId='transactionDetailsPhoto' className='w-full h-full object-cover' src={photoUrl} />
        </div>
      )}
    </div>
  );
};

export default BusinessPictureMap;
